import { requestGet, requestPost, requestFormPost } from '@/common/request';
import { ACE_API_DOMAIN } from './domain';

export function fetchGet(url, options) {
  return requestGet(`${ACE_API_DOMAIN}/${url}`, options);
}

export function fetchPost(url, options) {
  return requestPost(`${ACE_API_DOMAIN}/${url}`, options);
}

export function fetchFormPost(url, options) {
  return requestFormPost(`${ACE_API_DOMAIN}/${url}`, { body: JSON.stringify(options) }, { contentType: 'form' });
}
